import React, { Component, useEffect, useState } from 'react';
import t from '../../utils/translateUtil';
import ModalAlert from '../../components/ModalAlert';
import {portal_config} from '../../../portal.config'
import CurrentLocationView from './CurrentLocationView';
import Geocode from "react-geocode";
import crmservices from '../../wsclient/crmservices';
import CurrentLocationMap from './CurrentLocationMap';
import { checkCountrySupport } from '../../utils/common';
function CurrentLocationControler(props) {
    const [active, setActive] = useState('map');
    const [showLoading, onShowLoading] = useState(false);
    const [address_info, setAddressInfo] = useState(null);
    const [validation, setValidation] = useState({});
    const [address_list, setAddressList] = useState([]);
    const [error, setError] = useState({
        showAlert: false,
        title: '',
        message: '',
        status: '',
    });
    const [isDisableCountryField, setDisableCountryField] = useState(false);
    const [locationCheckTimer,setLocationCheckTimer] = useState(null);
    const [isRunning, setGetLocationStatus] = useState('start');
    const [currentLocation, setCurrentLocation] = useState(null);
    const [not_support_region, setNotSupportRegion] = useState(null);

    useEffect(() => {
        if (isRunning == 'start') {
            let locationCheckTimer = setInterval(() => { getLocation(); }, 500);
            setLocationCheckTimer(locationCheckTimer)
        } else {
            stopCheckingLocation();
        }
        return () => clearInterval(locationCheckTimer);
    }, [isRunning]);


    const stopCheckingLocation = () =>{
        setGetLocationStatus('stop');
        if (locationCheckTimer) {
            clearInterval(locationCheckTimer);
        }
    }
    const getLocation = async() =>{
        onShowLoading(true);
        if (currentLocation) {
            stopCheckingLocation();
            onShowLoading(false)
            return;
        }
        else {
            await navigator.geolocation.getCurrentPosition((location) => {
                var currentLocation = {
                    lat: location.coords.latitude,
                    lon: location.coords.longitude,
                }
                //HARDCODE for test
                // var currentLocation = {
                //     lat: 35.157322,
                //     lon: 33.313751,
                // }
                setCurrentLocation(currentLocation);
                getLocationInfo(currentLocation)
                stopCheckingLocation();
            }, (err) => {
                console.log('getLocation err', err)
                onShowLoading(false);
                stopCheckingLocation();
                showAlert(true, t('enable_location_permissions'));
            }, {
                timeout: 5000,
                enableHighAccuracy: false
            });
        }
        onShowLoading(false);
    }
    const getLocationInfo = async(currentLocation) =>{
        onShowLoading(true)
       var addresses = null
       var latlng = currentLocation.lat+', '+currentLocation.lon
      // console.log(' getLocationInfo======latlng=',latlng)
       try {
        var result = await crmservices.contacts.findAddress({ latlng: latlng });
       // console.log('getLocationInfo result=', result)
        if (result.code == 'OK') {
            addresses = result.data.content ? result.data.content : [];
            setAddressList(addresses)
        }
        } catch (error) {
            console.log("addresses lookup exception:", error);
        }
        onShowLoading(false)
    }
    const onSelectAddress = (address) =>{
        //console.log('onSelectAddress===',address)
        var isSupport = checkCountrySupport(address.country_code);
        if (isSupport) {
            if (address.address) {
                address.address_line_1 = address.address;
            }
            if (address.country_code) {
                setDisableCountryField(true);
            }
            setAddressInfo(address);
            setActive('form')
        }else{
            showAlert(t('SUCCESS'), t('NOT_SUPPORT_REGION'));
        }
    }
    // const onAddressInfo = (detail, latitude, longitude) =>{
    //     try {
    //         var address_component = detail.address_components;
    //         var formatted_address = detail.formatted_address;
    //         var addressInfor = clearAddInfor();
    //         if (address_component && address_component.length > 0) {
    //             address_component.forEach(element => {
    //                 if (element.types.length > 0) {
    //                     if (element.types[0] === 'country') {
    //                         addressInfor.country_code = element.short_name;
    //                     } else if (element.types[0] === 'postal_code') {
    //                         addressInfor.postal_code = element.long_name;
    //                     } else if (element.types[0] === 'locality') {
    //                         addressInfor.state_province_county = element.long_name;
    //                     }else if (element.types[0] === 'administrative_area_level_1') {
    //                         addressInfor.town_city = element.long_name;
    //                     }
    //                 }
    //             });
    //         }
    //         if (latitude)
    //             addressInfor.lat = latitude;
    //         if (longitude)
    //             addressInfor.lon = longitude;
    //         if(formatted_address){
    //             addressInfor.address_line_1 = formatted_address;
    //         }
    //         if(detail.place_id){
    //             addressInfor.googlePlaceId = detail.place_id;
    //         }


    //         setAddressInfo(addressInfor);
    //         if (addressInfor.country_code !== 'CYP' && addressInfor.country_code !== 'CY'){
    //             //console.log('CurrentLocationController currentAddress========',addressInfor)
    //             showAlert(t('SUCCESS'), t('NOT_SUPPORT_REGION'));
    //             setNotSupportRegion(true)
    //         }
    //     } catch (error) {
    //         console.log("set address info exception:", error);
    //     }
    // }
    const clearAddInfor = () =>{
        var addressInfor = {
            town_city: "",
            postal_code: "",
            district: "",
            country_code: "",
            address_line_1:"",
            googlePlaceId:"",
            state_province_county:"",
            lat:"",
            lon:""
        }
        return addressInfor;
    }
    const onHandleChange = (type, value) =>{
        if (type == 'country_code') {
            setDisableCountryField(false);
        }
        setAddressInfo(prevState=>({
            ...prevState,
            [type]: value
        }))
    }
    const onCurrentLocation = async (values) =>{
            var new_address_info = {...address_info}
            new_address_info.address_line_1 = values.address_line_1
            new_address_info.address_line_2 = values.address_line_2
            new_address_info.postal_code = values.postal_code


            if (!new_address_info.country_code)
                new_address_info.country_code = 'CYP'

            if (!new_address_info.country_code) {
                new_address_info.country_code = 'CYP'
            }

            if (new_address_info.address_line_1 ) {
                props.setCurrentLocation(new_address_info);
            }
    }
    const showAlert = async(status, message, title) =>{
        onShowLoading(false);
        setError({                
            showAlert: true,
            title: title,
            message: message,
            status: status,
        })
    }
    const onCloseAlert = () =>{
        onShowLoading(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: '',
        })
    }
    const onSelectLocation = (e) =>{
       // console.log('onSelectLocation e=',e);
         var currentLocation = {}
         currentLocation.lat = e.lat;
         currentLocation.lon = e.lng;
         setCurrentLocation(currentLocation)
        getLocationInfo(currentLocation)
        //this.setState({ currentLocation: location }) 
    }
        
    return (
        <div>
            {active==='form'&&<CurrentLocationView
                showLoading = {showLoading} 
                open = {props.open}
                onClose = {props.onClose}
                onSubmit ={onCurrentLocation}
                address_info = {address_info}
                onHandleChange = {onHandleChange}
                mode = {props.mode}
                onSelectAddress = {onSelectAddress}
                not_support_region = {not_support_region}
                isDisableCountryField={isDisableCountryField}/>}
            {active==='map'&&<CurrentLocationMap
                open = {active==='map'}
                onClose = {props.onClose}
                showLoading={showLoading}
                address_list={address_list}
                currentLocation = {currentLocation}
                onSelectAddress = {onSelectAddress}
                onSelectLocation = {onSelectLocation}
                />}    
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
            />
        </div>
    );
}

export default CurrentLocationControler;